export default {
  languagesArray: (state) =>
      Object.entries(state.languages).map(([key, value]) => ({
        code: key,
        name: value,
      })),
  currentLanguage: (state, getters) =>
      getters.languagesArray.find((o) => o.code === state.language),
}
